import React from "react";
import {
	Button,
	CardFooter,
	InputGroup,
	Label,
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Input,
	Row,
} from "reactstrap";
import { ReactComponent as BackIcon } from "../../../../../assets/utils/images/svgs/arrow-left.svg";
import { ReactComponent as CalendarIcon } from "../../../../../assets/utils/images/svgs/calendar-blue.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { useUrenoverzichtContext } from "./context/UrenoverzichtContext";
import { useGebruikerContext } from "../../Context/GebruikerContext";
import DatePicker from "react-datepicker";
import moment from "moment";

export default function Footer() {
	const { adminCommunityList, filterCommunity, setActiveTab, userTabs } = useGebruikerContext();
	const {
		dropdownOpen,
		toggle,
		handleCheckboxChange,
		startDate,
		setStartDate,
		endDate,
		setEndDate,
	} = useUrenoverzichtContext();

	return (
		<div className="chat-layout-footer" style={{ height: "80px" }}>
			<CardFooter className="chat-layout-footer__inner gebruikers-footer">
				<div className="d-flex gap-3 align-items-center justify-content-between w-100">
					<div className="d-flex flex-row gap-3">

						<Dropdown isOpen={dropdownOpen} toggle={toggle}>
							<DropdownToggle className="form-select">Alle besturen</DropdownToggle>
							<DropdownMenu>
								{adminCommunityList.map((item) => {
									return (
										<DropdownItem
											key={item.iCommunityId}
											toggle={false}
											className="d-flex justify-content-between"
										>
											{item.vCommunityName}
											<Input
												type="checkbox"
												name={item.vCommunityName}
												value={item.iCommunityId}
												checked={filterCommunity.some(
													(community) =>
														community.iCommunityId === item.iCommunityId
												)}
												onChange={handleCheckboxChange}
											/>
										</DropdownItem>
									);
								})}
							</DropdownMenu>
						</Dropdown>

						<div className="d-flex flex-row align-items-center">
							<Row className="form-checkbox-styling px-0 flex-nowrap">
								<div className="filterBy p-0 d-flex align-items-center justify-content-end w-auto">
									<label className="mb-0 mx-2">Begindatum</label>
								</div>
								<div className="selectBy p-0 w-auto me-3">
									<InputGroup>
										<div className="customDatePicker">
											<DatePicker
												locale="nl"
												className="form-control"
												dateFormat="dd-MM-yyyy"
												selected={
													startDate
														? moment(startDate, "MM/DD/YYYY", true).toDate()
														: new Date()
												}
												onChange={(date) => {
													const formattedDate = moment(date).isValid()
														? moment(date).format("MM/DD/YYYY")
														: "";
													setStartDate(formattedDate);
												}}
											/>
											<FontAwesomeIcon
												icon={faCalendarAlt}
												className="datepicker-icon-FontAwesome"
											/>
										</div>
									</InputGroup>
								</div>
							</Row>
						</div>

						<div className="d-flex flex-row align-items-center">
							<Row className="form-checkbox-styling px-0 flex-nowrap">
								<div className="filterBy p-0 d-flex align-items-center justify-content-end w-auto">
									<label className="mb-0 mx-2">Einddatum</label>
								</div>
								<div className="selectBy p-0 w-auto">
									<InputGroup>
										<div className="customDatePicker">
											<DatePicker
												locale="nl"
												className="form-control"
												dateFormat="dd-MM-yyyy"
												selected={
													endDate
														? moment(endDate, "MM/DD/YYYY", true).toDate()
														: new Date()
												}
												onChange={(date) => {
													const formattedDate = moment(date).isValid()
														? moment(date).format("MM/DD/YYYY")
														: "";
													setEndDate(formattedDate);
												}}
											/>
											<FontAwesomeIcon
												icon={faCalendarAlt}
												className="datepicker-icon-FontAwesome"
											/>
										</div>
									</InputGroup>
								</div>
							</Row>
						</div>
					</div>
					<div className="ms-auto">

						<Button
							outline
							className="btn-outline-primary-blue ms-auto mt-auto"
							onClick={() => {
								setActiveTab(userTabs.Matchcodes);
							}}
							type="button"
							color="primary"
						>
							<BackIcon />
						</Button>
					</div>
				</div>
			</CardFooter>
		</div>
	);
}
